import { Stack } from '@backyard-ui/core'

import { Filters } from './Filters'
import { IS_CATEGORY } from '../../utils/constants'
import { SelectedFilters } from './SelectedFilters'
import { HierarchicalMenu } from './HierarchicalMenu'
import { MobileFilter } from './MobileFilter'
import { SortBy } from './SortBy'
import { useTabContext } from '../../contexts/TabContext'
import { useServerContext } from '../../routes/routes.context'

const AsideWithTabs = () => {
  const { activeTab } = useTabContext()

  return (
    <MobileFilter>
      <Stack direction="column">
        <SortBy />
        <SelectedFilters />

        {activeTab === 'products' && (
          <>
            <HierarchicalMenu />
            <Filters />
          </>
        )}

        {activeTab === 'services' && <Filters />}
      </Stack>
    </MobileFilter>
  )
}

const Aside = () => {
  const { isServicesSearchbarEnabled = false } = useServerContext()

  if (!isServicesSearchbarEnabled || IS_CATEGORY) {
    return (
      <MobileFilter>
        <Stack direction="column">
          <SortBy />
          <SelectedFilters />
          <HierarchicalMenu />
          <Filters />
        </Stack>
      </MobileFilter>
    )
  }

  return <AsideWithTabs />
}

export default Aside
